import { createRequestWithdrawal, fetchRequestWithdrawal } from "./asyncThunk";

export const fetchRequestWithdrawalBuilder = (builder) => {
  builder.addCase(fetchRequestWithdrawal.pending, (state) => {
    state.requestWithdrawal.loading = true;
  });
  builder.addCase(fetchRequestWithdrawal.fulfilled, (state, { payload }) => {
    const { page, total, requests } = payload;
    state.requestWithdrawal.loading = false;
    state.requestWithdrawal.data = requests;
    state.requestWithdrawal.page = page;
    state.requestWithdrawal.total = total;
  });
  builder.addCase(fetchRequestWithdrawal.rejected, (state) => {
    state.requestWithdrawal.loading = false;
  });
};

export const createRequestWithdrawalBuilder = (builder) => {
  builder.addCase(createRequestWithdrawal.pending, (state) => {
    state.createRequestWithdrawalPending = true;
  });
  builder.addCase(createRequestWithdrawal.fulfilled, (state, { payload }) => {
    const { request } = payload;
    state.createRequestWithdrawalPending = false;
    state.requestWithdrawal.data = [request, ...state.requestWithdrawal.data];
  });
  builder.addCase(createRequestWithdrawal.rejected, (state) => {
    state.createRequestWithdrawalPending = false;
  });
};
